export default {
  parent_total_points: 0,
  parent_points_sum: [],
  parent_points_mean: [],
  child_points: {},
  child_goals: {},
  child_goals_disapproved: {},
  child_unique_points: [],
  error: false,
  errorMessage: "",
  parent_points_per_time: [],
  child_star_progress: [],
  child_goals_progress: [],
  child_own_stars: [],
  popups: {
    child: {},
    parent: {}
  }
};